export const FETCH_WEATHER_ACTION = '@fmc/weather/FETCH_WEATHER_ACTION';
export const FETCH_WEATHER_FAILURE = '@fmc/weather/FETCH_WEATHER_FAILURE';
export const FETCH_WEATHER_SUCCESS = '@fmc/weather/FETCH_WEATHER_SUCCESS';
export const CLEAR_WEATHER = '@fmc/weather/CLEAR_WEATHER';
